import { getManualContactName } from 'utils/connect-branding';

export const generateEmailWithRandomNumberAlias = (
  email: unknown,
  randNumberFn: () => number = () =>
    Math.floor(Math.random() * 900000) + 100000,
): string | null => {
  if (email === undefined) return null;
  if (typeof email === 'string') {
    try {
      const parts = email.split('@');
      const newEmail = `${parts[0]}+${randNumberFn()}@${parts[1]}`;
      return newEmail;
    } catch (err) {
      return null;
    }
  }
  // if there is no configured email or some error above, default whatever was passed in
  return null;
};

export const getNameParts = (
  client: {
    name?: string;
    manualConfig?: Record<string, any> | null;
    settings?: Record<string, any> | null;
  },
  clientName?: string,
) => {
  if (client?.manualConfig?.name) {
    const [firstName, ...rest] = client.manualConfig.name.split(' ');
    const lastName = rest.join(' ') || 'Admin';
    const fullName = client.manualConfig.name;
    return { firstName, lastName, fullName };
  }

  const firstName = getManualContactName(client, clientName);
  const lastName = 'Admin';
  const fullName = `${firstName} ${lastName}`;
  return { firstName, lastName, fullName };
};

const EPOCH_2025 = Math.floor(
  new Date('2025-01-01T00:00:00Z').getTime() / 1000,
);

export const generateCompanyEmailAlias = (
  email: unknown,
  companyName: string | undefined,
  nowFn: () => number = () => Math.floor(Date.now() / 1000),
): string | null => {
  if (email === undefined || typeof email !== 'string') return null;

  const [localWithAlias, domain] = email.split('@');
  if (!domain) return null;

  const local = localWithAlias.split('+')[0];
  const company = (companyName || '')
    .split(/\s+/)[0]
    .replace(/[^a-zA-Z]/g, '')
    .toLowerCase();
  const suffix = nowFn() - EPOCH_2025;

  const alias = company ? `${company}_${suffix}` : `${suffix}`;
  return `${local}+${alias}@${domain}`;
};

export const removeNumbers = (str: string) => {
  return str
    .replace(/\d/g, ' ')
    .split(' ')
    .filter((seg) => seg.length !== 0)
    .join(' ');
};
